import type {
    AgriCategory,
    ListAgriculturalMaterialsParams,
} from '@/lib/api/agricultural-materials-api'

export const ALL_CATEGORIES = 'all'
export const ALL_STATUSES = 'all'

export type CategoryFilter = AgriCategory | typeof ALL_CATEGORIES
/** Xoá vật tư là tắt (is_active=false), nên "đã ngưng" chính là "đã xoá". */
export type StatusFilter = 'active' | 'inactive' | typeof ALL_STATUSES

/** Trạng thái mặc định khi mở trang: chỉ hiện vật tư còn dùng. */
export const DEFAULT_STATUS: StatusFilter = 'active'

interface FilterState {
    search: string
    category: CategoryFilter
    status: StatusFilter
}

interface BuildListParamsInput extends FilterState {
    page: number
    perPage: number
}

/**
 * Có bộ lọc nào đang thu hẹp danh sách không.
 *
 * Dùng để chọn câu cho danh sách rỗng: rỗng vì bộ lọc khác hẳn rỗng vì chưa có
 * dữ liệu. Trạng thái mặc định đã là một bộ lọc ("đang sử dụng"), nên hàm này
 * trả true ngay từ lần mở trang đầu tiên — cố ý: nói "Chưa có vật tư nào" trong
 * khi vật tư vẫn còn, chỉ đang bị ẩn, sẽ làm người dùng tưởng mất sạch dữ liệu.
 */
export function hasActiveFilters({
    search,
    category,
    status,
}: FilterState): boolean {
    return (
        search !== '' || category !== ALL_CATEGORIES || status !== ALL_STATUSES
    )
}

/**
 * Gom state của bộ lọc thành query params. Field nào không lọc thì bỏ hẳn ra
 * khỏi object — backend coi "vắng mặt" là không lọc, gửi undefined lên sẽ thành
 * chuỗi rỗng trên query string và làm hỏng bộ lọc.
 */
export function buildListParams({
    page,
    perPage,
    search,
    category,
    status,
}: BuildListParamsInput): ListAgriculturalMaterialsParams {
    return {
        page,
        per_page: perPage,
        ...(search ? { search } : {}),
        ...(category !== ALL_CATEGORIES ? { category } : {}),
        ...(status !== ALL_STATUSES ? { is_active: status === 'active' } : {}),
    }
}
